import { Component, HostBinding, Input } from '@angular/core';

import { SOURCE_MAPPINGS } from '../models/source.model';


@Component({
  selector: 'app-source',
  templateUrl: './source.component.html',
  styleUrls: ['./source.component.scss']
})
export class SourceComponent {
  @Input() source: number;
  @Input() compact = false;

  @HostBinding('class.source') private _clsSource = true;

  get valid(): boolean {
    return SOURCE_MAPPINGS.has(this.source);
  }

  get abbr(): string {
    const source = SOURCE_MAPPINGS.get(this.source);
    return source ? source.abbr : null;
  }

  get text(): string {
    const source = SOURCE_MAPPINGS.get(this.source);
    return source ? source.text : null;
  }

  get tooltip(): string {
    if (!this.compact) {
      return '';
    }
    const source = SOURCE_MAPPINGS.get(this.source);
    return source ? source.tooltip : null;
  }

  get url(): string {
    const source = SOURCE_MAPPINGS.get(this.source);
    return source ? source.url : null;
  }

  get cls(): string {
    const abbr = this.abbr;
    if (!abbr) {
      return '';
    }
    return 'source__wrapper source__wrapper--' + abbr.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '');
  }
}
